import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ActionSheetController,
  ViewController,
  AlertController,
  ToastController
} from 'ionic-angular';
import { AuthProvider } from '@providers/auth/auth';
import { CertificacionProvider } from '@providers/certificacion/certificacion';
import { LanguageProvider, LanguageEnum } from '@providers/language/language';
import { Jugador } from '@domain/jugador';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingController } from 'ionic-angular';
import { LoginPage } from '@pages';
import { ImageViewerController } from 'ionic-img-viewer';
import { Equipo } from '@domain/equipo';
import { VERSION, ASSETS } from '@env';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-perfil',
  templateUrl: 'perfil.html',
})
export class PerfilPage {

  version = VERSION;
  jugador: Jugador = new Jugador;
  equipo: Equipo;
  avatar: any = {
    mime: '',
    avatar: '',
  };
  avatarOriginal: any = {
    mime: '',
    avatar: '',
  };
  loader: any;
  _imageViewerCtrl: ImageViewerController;
  nuevaContrasenia: string;
  confirmarContrasenia: string;
  areasJugador: Array<any> = [];

  certificado: any;
  PATH_LOGO: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private camera: Camera,
    public loadingCtrl: LoadingController,
    public sanitizer: DomSanitizer,
    public viewCtrl: ViewController,
    public imageViewerCtrl: ImageViewerController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private actionSheetCtrl: ActionSheetController,
    private languageProvider: LanguageProvider,
    private translate: TranslateService,
    private certificacionProvider: CertificacionProvider,
  ) {

    this.PATH_LOGO = `${ASSETS.PATH_LOGO}`
    this._imageViewerCtrl = imageViewerCtrl;

    this.authProvider.getSession()
      .then(jugador =>  {
        this.jugador = jugador;
        return this.authProvider.getAvatar();
      })
      .then(avatar => {
        this.avatar = avatar;
        this.avatarOriginal = Object.assign({}, this.avatar);
        return this.authProvider.getEquipo();
      })
      .then( equipo => {
        this.equipo = equipo;

        return this.authProvider.getAreasJugador(this.jugador._id);
      })
      .then( areasJugador => {
        this.areasJugador = areasJugador;
        return this.authProvider.getScorePersonal();
      });
  }

  async ionViewDidLoad() {
    let equipo = await this.authProvider.getEquipo();
    let response = await this.certificacionProvider.get(equipo.area.liderEntrenamiento);

    this.certificado = response;
  }

  showAvatar(avatar) {
    const imageViewer = this._imageViewerCtrl.create(avatar);
    imageViewer.present();
  }

  bypassSecurityTrustResourceUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  changeAvatar() {

    const actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('perfil.changeAvatar.title'),
      buttons: [
        {
          text: this.translate.instant('perfil.changeAvatar.foto') ,
          handler: () => {
            this._tomarFoto();
          }
        },{
          text: this.translate.instant('perfil.changeAvatar.biblioteca'),
          handler: () => {
            this._seleccionarFoto();
          }
        },{
          text: this.translate.instant('perfil.changeAvatar.cancelar'),
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  private _tomarFoto() {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      // sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      correctOrientation: true,
      targetWidth: 200
    }

    this.loader = this.loadingCtrl.create();
    this.loader.present();

    this.camera.getPicture(options).then((imageData) => {
      this.avatar = {
        mime: 'image/jpeg',
        avatar: imageData,
      };

      this.guardaAvatar();
    }, (err) => {
      this.loader.dismiss();
    });
  }

  private _seleccionarFoto() {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      correctOrientation: true,
      targetWidth: 200
    }

    this.loader = this.loadingCtrl.create();
    this.loader.present();

    this.camera.getPicture(options).then((imageData) => {
      this.avatar = {
        mime: 'image/jpeg',
        avatar: imageData,
      };

      this.guardaAvatar();

    }, (err) => {
      this.loader.dismiss();
    });
  }

  guardaAvatar() {
    this.authProvider.setAvatar(this.jugador._id, this.avatar)
    .then( response => {
      this.authProvider.saveAvatar(this.avatar);

      this.avatarOriginal = Object.assign({}, this.avatar);
      this.loader.dismiss();
    })
    .catch( e => {

      this.avatar = Object.assign({}, this.avatarOriginal);
      this.loader.dismiss();
    });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  logout() {
    this.authProvider.cerrarSesion()
    .then( _ => {
      this.navCtrl.setRoot(LoginPage);
    })
  }

  cambiarContrasenia() {
    if(!this.nuevaContrasenia || this.nuevaContrasenia.length < 6) {
      this.verificaContrasenias(this.translate.instant('perfil.cambiarContrasenia.longitud'));
      return false;
    }

    if(this.nuevaContrasenia != this.confirmarContrasenia ) {
      this.verificaContrasenias(this.translate.instant('perfil.cambiarContrasenia.contrasenias'));
      return false;
    }

    this.authProvider.cambiaContrasenia(this.jugador._id, this.nuevaContrasenia)
      .then( response => {
        this.nuevaContrasenia = '';
        this.confirmarContrasenia = '';

        const toast = this.toastCtrl.create({
           message: this.translate.instant('perfil.cambiarContrasenia.ok'),
           duration: 4000,
           position: 'bottom'
        });
        toast.present();
      })
      .catch( e => {
        const alert = this.alertCtrl.create({
          title: '¡Error!',
          subTitle: e.error.message,
          buttons: ['OK']
        });
        alert.present();
      })
  }

  verificaContrasenias(message: string) {
    const alert = this.alertCtrl.create({
      title: '¡Error!',
      subTitle: message,
      buttons: ['OK']
    });
    alert.present();
  }

  async _cambiarIdioma(lang) {
    this.translate.reloadLang(lang);
    this.languageProvider.set(lang);

    const loader = this.loadingCtrl.create({
       content: "Please wait...",
    });
    loader.present();
    setTimeout( () => window.location.reload(true), 500);
  }

  async cambiarIdioma() {
    const es = await this.translate.instant(LanguageEnum.ES);
    const en = await this.translate.instant(LanguageEnum.EN);

    const idiomas = [
      {
        text: es,
        handler: () => {
          this._cambiarIdioma(LanguageEnum.ES)
        }
      },
      {
        text: en,
        handler: () => {
          this._cambiarIdioma(LanguageEnum.EN)
        }
      },
      {
        text: this.translate.instant('perfil.cambiarIdioma.cancel'),
        role: 'cancel',
        cssClass: 'color-danger-as'
      }
    ]

    const actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('perfil.cambiarIdioma.idiomas'),
      buttons: idiomas
    });
    actionSheet.present();
  }

  cambiarArea() {
    let areas: any = this.areasJugador.map( e =>  {
      return {
        text: e.area.nombre,
        cssClass: e._id == this.equipo._id ? 'active-area': '',
        handler: () => {
          this._cambiaArea(e._id);
        }
      };
    });
    areas.push({
      text: this.translate.instant('perfil.cambiarArea.cancel'),
      role: 'cancel',
      cssClass: 'color-danger-as'
    });

    const actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('perfil.cambiarArea.areas'),
      buttons: areas
    });
    actionSheet.present();

  }

  private _cambiaArea(equipoId) {
    let equipo = this.areasJugador.find( e => e._id ==  equipoId);

    if( this.equipo._id != equipo._id ){
        this.equipo = equipo;
        this.authProvider.saveEquipo(equipo);

        const loader = this.loadingCtrl.create({
           content: "Please wait...",
        });
        loader.present();
        this.authProvider.changeArea(true);
        setTimeout( () => window.location.reload(true), 500);

    }

  }

  handleBody(txt) {
    return txt ? txt.split("\n").join("<br>"): '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/perfil/perfil.ts